import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import {
  getTareaEstadoColors,
  getFacturaEstadoColors,
  getTipoTareaColors,
  getPlanEstadoColors,
  getPortalEstadoColors,
  badgeStyles,
} from "../styles/clientePortalStyles";
import { FiberManualRecord } from "@material-ui/icons";

// ==================== ESTILOS ====================

const useStyles = makeStyles((theme) => ({
  badge: {
    ...badgeStyles,
  },
  dot: {
    fontSize: 12,
  },
}));

/**
 * Componente StatusBadge - Badge para mostrar estados
 *
 * @param {string} estado - Estado a mostrar
 * @param {string} tipo - Tipo de badge: "tarea" | "factura" | "tipoTarea"
 * @param {boolean} showDot - Mostrar punto de color (default: true)
 * @param {string} customLabel - Label personalizado (sobrescribe el default)
 *
 * @example Badge de tarea
 * <StatusBadge estado="PENDIENTE" tipo="tarea" />
 *
 * @example Badge de factura
 * <StatusBadge estado="PAGADO" tipo="factura" />
 *
 * @example Badge de tipo de tarea
 * <StatusBadge estado="MES" tipo="tipoTarea" />
 *
 * @example Badge sin punto y label custom
 * <StatusBadge
 *   estado="TERMINADA"
 *   tipo="tarea"
 *   showDot={false}
 *   customLabel="Completada"
 * />
 */
export default function StatusBadge({
  estado,
  tipo = "tarea",
  showDot = true,
  customLabel,
}) {
  const classes = useStyles();

  // Obtener colores según el tipo
  let colors;
  switch (tipo) {
    case "tarea":
      colors = getTareaEstadoColors(estado);
      break;
    case "factura":
      colors = getFacturaEstadoColors(estado);
      break;
    case "tipoTarea":
      colors = getTipoTareaColors(estado);
      break;
    case "plan":
      colors = getPlanEstadoColors(estado);
      break;
    case "portal":
      colors = getPortalEstadoColors(estado);
      break;
    default:
      colors = {
        bg: "#F5F5F5",
        text: "#757575",
        dot: "#BDBDBD",
        label: estado,
      };
  }

  const label = customLabel || colors.label;

  return (
    <Box
      className={classes.badge}
      sx={{
        backgroundColor: colors.bg,
        color: colors.text,
      }}
    >
      {showDot && (
        <FiberManualRecord className={classes.dot} sx={{ color: colors.dot }} />
      )}
      <Typography
        variant="body2"
        component="span"
        sx={{
          fontSize: "inherit",
          fontWeight: "inherit",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
